(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jw-client-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jwc-client-gallery')) {
  customElements.define('jwc-client-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.resizeObserver?.observe(this.track);
        return;
      }
      this.initialized = true;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.thumbnailTrack = this.querySelector('[data-gallery-thumbnails]');
      this.counter = this.querySelector('[data-gallery-count]');
      this.index = 0;
      if (!this.track || !this.slides.length) return;
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.move(1));
      this.thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', event => {
        event.preventDefault();
        this.select(index);
      }));
      this.track.addEventListener('keydown', event => {
        const targets = { ArrowLeft: -1, ArrowRight: 1, Home: 0, End: this.maxIndex };
        if (!(event.key in targets)) return;
        event.preventDefault();
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') this.move(targets[event.key]);
        else this.select(targets[event.key]);
      });
      this.track.addEventListener('scroll', () => {
        if (this.scrollPending) return;
        this.scrollPending = true;
        requestAnimationFrame(() => {
          this.scrollPending = false;
          const index = Math.min(this.maxIndex, Math.max(0, Math.round(this.track.scrollLeft / this.step)));
          if (index !== this.index) this.update(index);
        });
      }, { passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      });
      this.resizeObserver = new ResizeObserver(() => this.refreshLayout());
      this.resizeObserver.observe(this.track);
      this.refreshLayout();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
    refreshLayout() {
      this.visibleCount = Math.min(this.slides.length, parseInt(getComputedStyle(this).getPropertyValue('--jwc-columns'), 10) || 1);
      this.maxIndex = Math.max(0, this.slides.length - this.visibleCount);
      this.step = this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
      this.querySelectorAll('.jwc-gallery-arrow').forEach(button => { button.hidden = this.maxIndex === 0; });
      this.select(Math.min(this.index, this.maxIndex), 'instant');
    }
    move(direction) {
      const next = this.index + direction;
      this.select(next < 0 ? this.maxIndex : next > this.maxIndex ? 0 : next);
    }
    select(index, preferredBehavior) {
      const next = Math.min(this.maxIndex, Math.max(0, index));
      const behavior = preferredBehavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
      this.track.scrollTo({ left: this.slides[next].offsetLeft - this.slides[0].offsetLeft, behavior });
      if (behavior === 'instant') this.update(next);
    }
    update(index) {
      this.index = index;
      this.thumbnails.forEach((thumbnail, position) => {
        thumbnail.dataset.visible = String(position >= index && position < index + this.visibleCount);
        if (position === index) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });
      const last = Math.min(this.slides.length, index + this.visibleCount);
      const range = last > index + 1 ? `${index + 1}–${last}` : `${index + 1}`;
      this.counter.textContent = `${range} / ${this.slides.length}`;
      const thumbnail = this.thumbnails[index];
      const left = thumbnail.offsetLeft - (this.thumbnailTrack.clientWidth - thumbnail.offsetWidth) / 2;
      this.thumbnailTrack.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
